<template>
  <div class="index" >
    <div class="test"></div>
    <div class="content-right">
      <div class="titlelogo">
        <img src="@/assets/logo_khy.png" alt="" />
        <h3>医疗机构在线考核云平台</h3>
      </div>
      <div class="login-content">
        <div class="btn">
          <span :class="{ isbtn: isActive }" @click="login">欢迎登录</span>
        </div>
        <div class="kuang">
          <sin-up></sin-up>
        </div>
      </div>
      <div class="subject">
        <span @click="toWebsite">前往专题介绍页></span>
        <span @click="toYikaola">前往医考拉></span>
      </div>
      <div class="foot">
        Copyright 2005-2018 英腾教育科技股份有限公司 备案信息：桂ICP备09009842号
      </div>
    </div>
  </div>
</template>

<script>
import SinUp from './components/sin_upCom';

export default {
  name: 'LoginIndex',
  components: {
    SinUp
  },
  data () {
    return {
      isActive: true,
      
    };
  },
  methods: {
    test(){
      // console.log('ssssss');
    },
    login () {
      if (this.isActive === false) {
        this.isActive = !this.isActive;
        this.$router.push({ name: 'Sin_up' });
      }
    },
    logincode () {
      if (this.isActive === true) {
        this.isActive = !this.isActive;
        this.$router.push({ name: 'Sin_code' });
      }
    },
    // 跳转到官网
    toWebsite() {
      window.location.href = 'http://www.tibosi.com/'
    },
    // 跳转到医考拉
    toYikaola() {
      window.location.href = 'https://xxypc.tibosi.com/'
    }
  }
};
</script>

<style lang="scss" scoped>
.index {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  background-image: url(../../assets/background-img.png);
  opacity: 1;
  &::before {
    content: "";
    width: 100%;
    height: 100%;
  }
  .titlelogo {
    margin-left: 30px;
    display: flex;
    flex-direction: column;
    color: rgb(67, 66, 170);
    align-items: center;
    margin-top: 40px;
    img {
      width: 100px;
      height: 100px;
      border-radius: 10px;
    }
    h3 {
      margin-top: 20px;
      //  width: 440px;
      height: 56px;
      font-size: 26px;
      font-weight: 400;
      line-height: 56px;
      color: #333333;
    }
  }
  .content-right {
    width: 600px;
    height: 100%;
    position: absolute;
  //  margin: auto;
  }
}
.subject {
  padding-right: 50px;
  height: 60px;
  margin-top: 40px;
  span {
    font-size: 13px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 18px;
    color: #4aa8ff;
    color: #1890ff;
    float: right;
    cursor: pointer;
    margin-left: 20px;
  }
}
.login-content {
  box-shadow: 0 0 15px rgb(211, 210, 210);
  border-radius: 30px;
  margin-left: 50px;
  margin-top: 10px;
  width: 514px;
  height: 448px;
  background-color: rgb(255, 255, 255);
  padding-top: 30px;

  h3 {
    display: block;
    color: rgb(53, 90, 201);
    font-size: 26px;
    padding-left: 100px;
  }
}
.btn {
  display: flex;
  justify-content: center;
  span {
    display: inline-block;
    height: 45px;
    cursor: pointer;
    width: 75px;
    font-family: "Microsoft Yahei";
    font-weight: 600;
    text-align: center;
    &:nth-child(2) {
      margin-left: 100px;
    }
  }
}
.isbtn {
  border-bottom: 4px solid #1890ff;
  font-size: 18px;
  color: #333333;
  font-weight: bold;
  font-family: PingFang SC;
}
.kuang {
  margin-left: 30px;
  width: 450px;
  height: 300px;
}
.test {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  background: rgba(194, 227, 255, 0.6);
}
.foot {
  margin-top: 130px;
  height: 10px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #999999;
}
</style>
